export interface ToolParam {
  key: string;
  required: boolean;
  description: string;
}

export interface ToolDef {
  params: ToolParam[]; // vuoto = parametri liberi (es. upsertLead)
}

export const TOOL_REGISTRY: Record<string, ToolDef> = {
  getAgeFromDateOfBirth: {
    params: [
      { key: "date_of_birth", required: true, description: "Data di nascita (field_key)" },
    ],
  },
  isSalaryBackedLoanLocked: {
    params: [
      { key: "start_date", required: true, description: "Data decorrenza contratto (field_key)" },
      { key: "duration", required: true, description: "Durata mesi (field_key o numero)" },
      { key: "tolerance_months", required: false, description: "Mesi tolleranza (opz., default 0)" },
    ],
  },
  setAsNotInterested: {
    params: [], // tenant_id e user_phone iniettati dal FlowProcessor
  },
  requestCall: {
    params: [
      { key: "callback_day", required: true, description: "Giorno ricontatto (field_key)" },
      { key: "callback_time_slot", required: true, description: "Fascia oraria (field_key)" },
      { key: "lead_id", required: false, description: "ID lead (opz.)" },
    ],
  },
  upsertLead: {
    params: [], // kwargs liberi
  },
};
